import VotingHandler, { CallVotingHandlerController } from './VotingHandler'

export { CallVotingHandlerController, VotingHandler }
export default VotingHandler
